import { createSlice } from '@reduxjs/toolkit'

export const userSlice = createSlice({
    name: 'user',
    initialState: {
        userDetail: {},
        isLogin: false
    },
    reducers: {
        setUserDetail: (state, action) => {
            state.userDetail = action.payload
        },
        setIsLogin: (state, action) => {
            state.isLogin = action.payload
        }
    },
})

export const { setUserDetail, setIsLogin } = userSlice.actions
const userReducer = userSlice.reducer

export default userReducer
